import PropTypes from 'prop-types';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import HomepageSliderBody from './Body';

const View = ({ data, className }) => (
  <div className={className}>
    <HomepageSliderBody slides={data.slides} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
};

export default withBlockExtensions(View);
